import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const DialogConfirmation = ({ dialogText, open, onCloseFn }) => (
  <Dialog open={open} onClose={onCloseFn}>
    <DialogTitle>Operación exitosa</DialogTitle>
    <DialogContent>
      <DialogContentText>{dialogText}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCloseFn} color="primary" variant="contained">
        Aceptar
      </Button>
    </DialogActions>
  </Dialog>
);

export default DialogConfirmation;

DialogConfirmation.propTypes = {
  dialogText: PropTypes.string,
  open: PropTypes.bool,
  onCloseFn: PropTypes.func
};
